import { cn } from "@/lib/utils";

type Env = "local" | "staging";

const ENV_CONFIG: Record<
  Env,
  { label: string; description: string; bar: string; dot: string; text: string }
> = {
  local: {
    label: "localhost",
    description: "Ambiente de Desenvolvimento",
    bar: "bg-pink-50 border-pink-200 dark:bg-pink-950/30 dark:border-pink-900",
    dot: "bg-pink-500",
    text: "text-pink-800 dark:text-pink-300",
  },
  staging: {
    label: "staging",
    description: "Ambiente de Homologação",
    bar: "bg-blue-50 border-blue-200 dark:bg-blue-950/30 dark:border-blue-900",
    dot: "bg-blue-500",
    text: "text-blue-800 dark:text-blue-300",
  },
};

export function EnvironmentBar() {
  const env = import.meta.env.VITE_ENV as string;

  if (env === "prod") return null;

  // Só o local é tratado explicitamente; qualquer outro ambiente não-prod
  // (staging/homologação, cujo VITE_ENV é 'stag') cai como staging.
  const config = env === "local" ? ENV_CONFIG.local : ENV_CONFIG.staging;

  return (
    <div
      className={cn("flex h-7 items-center gap-2 border-b px-4 md:px-6", config.bar, config.text)}
    >
      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", config.dot)} />
      <span className="font-mono text-[11px] font-medium tracking-wide">{config.label}</span>
      <span className="text-[11px] opacity-50">·</span>
      <span className="text-[11px]">{config.description}</span>
    </div>
  );
}
